import { render } from "./Recharge.vue?vue&type=template&id=8f2838d4&scoped=true"
import script from "./Recharge.vue?vue&type=script&lang=js"
export * from "./Recharge.vue?vue&type=script&lang=js"

import "./Recharge.vue?vue&type=style&index=0&id=8f2838d4&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2838d4"]])

export default __exports__